<section modalContainer background="true" rounded="true" class="rounded-2xl" invisibleWhitespace="true">
    <main class="bg-background rounded-xl flex flex-col w-full md:min-w-[500px] min-w-[320px]">
        <ng-container *ngTemplateOutlet="content" />
    </main>
</section>

<ng-template #content>
    <main class="flex flex-col md:max-w-[500px] max-w-[320px] h-full">
        <button (click)="close()" class="px-5 pt-5 md:px-8 md:pt-8 place-self-end">
            <app-icon name="material-symbols:close" class="self-end text-zinc-500" />
        </button>
        <section class="flex flex-col items-center justify-center w-full gap-6 px-5 py-8 md:p-8">
            <p class="text-2xl font-bold text-white">로그인 후 이용 가능</p>
            <p class="text-center text-zinc-400">해당 서비스는 로그인 후 이용 가능한 서비스 입니다.</p>
        </section>
        <section class="flex items-center w-full gap-3 p-5 border-t md:px-8 md:pb-8 border-neutral-800">
            <app-button (click)="close()" expand rounded="xl" color="zinc" size="lg">
                <span class="text-base text-white"> 닫기 </span>
            </app-button>
            <app-button (click)="login()" expand rounded="xl" size="lg" color="primary">
                <span class="text-base text-white"> 로그인 하기 </span></app-button
            >
        </section>
    </main>
</ng-template>
